import { LoginResult } from "../types/LoginResult.model";
import { LoginRequest } from "../types/LoginRequest.model";

export const authService = {
  async login(user: LoginRequest, eventName: string): Promise<LoginResult> {
    if(!eventName) return { success: false, error: "eventName dost not exist" };;
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/login/${eventName}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(user)
      });

      if (!response.ok) {
        return { success: false, error: "Invalid credentials" };
      }

      const data: LoginResult = await response.json();
   
      return data
    } catch (err) {
      return { success: false, error: "Network error" };
    }
  }
};